import { render, staticRenderFns } from "./FieldBirth.vue?vue&type=template&id=39fb0b1e&scoped=true"
import script from "./FieldBirth.vue?vue&type=script&lang=js"
export * from "./FieldBirth.vue?vue&type=script&lang=js"
import style0 from "./FieldBirth.vue?vue&type=style&index=0&id=39fb0b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb0b1e",
  null
  
)

export default component.exports